import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_77ud8qkk62: FaireBrandEntity = {
  token: "b_77ud8qkk62",
  type: "brand",
  name: "Karepango",
  avatarUrl:
    "https://cdn.faire.com/fastly/bb1ace6587d16535038232d5ae3871aabf701723fc49bbf57093a91af012d102.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/4d8cd5a5bb361dd4b3d3ab116cbaa769ff2bb475ff018d9c0dab667348cb0741.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/bb1ace6587d16535038232d5ae3871aabf701723fc49bbf57093a91af012d102.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4d8cd5a5bb361dd4b3d3ab116cbaa769ff2bb475ff018d9c0dab667348cb0741.jpeg",
  location: "Brooklyn, NY, USA",
  minimumOrderDollars: 100,
  rating: 4.8,
  reviewCount: 13,
  isInsider: true,
  description:
    "Karepango is a is grounded in Taiwanese and Japanese hospitality but inviting of everyone who might stop by along the way. Its loud designs encourage the magic of finding the smallest joys in everyday life, intended to bring a smile in the most unexpected times. We can always find reason to laugh if we look hard enough.",
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:28:14.439Z",
    importedBy: "entity-db-cli",
  },
};
